export const PATH = {
  DOCUMENTS: 'company/documents',
}
